<template>
  <div
    class="col-12 col-sm-8 col-md-6 col-xxl-4 mr-auto mx-auto"
    style="
      border: 1px solid #cccccc;
      border-radius: 8px;
      box-shadow: 0 2px 2px rgba(0, 0, 0, 0.16);
      font-family: IRANSansX-Regular;
      background: #fff;
    "
  >
    <div
      class="w-100 text-right p-4 pb-2"
      dir="rtl">
      <h4>
        <svg
          id="badge"
          style="width: 36px"
          xmlns="http://www.w3.org/2000/svg"
          x="0"
          y="0"
          enable-background="new 0 0 16 16"
          version="1.1"
          viewBox="0 0 16 16"
          xml:space="preserve"
        >
          <path
            id="path7"
            fill="#231f20"
            stroke="none"
            d="M5.25 9.847v4.342c0 .502.229.69.366.756.136.067.423.131.802-.184l.99-.825c.326-.273.879-.273 1.206 0l.989.824c.223.185.413.24.56.24a.534.534 0 0 0 .243-.056c.137-.067.366-.254.366-.756v-4.36a4.911 4.911 0 0 0 1.979-3.947C12.751 3.19 10.62 1 8.001 1S3.25 3.19 3.25 5.881c0 1.637.794 3.079 2 3.966zm5.021 4.342c0 .186-.048.276-.081.292-.033.017-.132-.002-.272-.12l-.99-.824c-.506-.421-1.331-.421-1.835 0l-.989.824c-.141.117-.241.136-.272.12-.033-.016-.081-.106-.081-.292v-4.036c.672.376 1.431.61 2.249.61.827 0 1.593-.238 2.271-.621v4.047zM8 1.514c2.343 0 4.25 1.96 4.25 4.367a4.389 4.389 0 0 1-1.962 3.669h-.017v.01A4.134 4.134 0 0 1 8 10.25c-2.343 0-4.25-1.96-4.25-4.368 0-2.407 1.907-4.367 4.25-4.367Z"
          />
        </svg>
        وضعیت اشتراک
      </h4>
    </div>
    <div class="container">
      <div class="row">
        <div
          class="col-12 mr-auto mx-auto"
          dir="rtl">
          <div class="card m-2 border-0">
            <a
              class="btn btn-outline-success w-100"
              href="http://localhost:8083/renew/">خرید</a>
          </div>

          <div
            class="card p-2 m-2"
            style="background-color: #f9f9f9">
            <div class="p-2 text-center">
              <div class="row">
                <div class="col-5">
                  <small> نوع کاربری </small>
                </div>

                <div class="col-7">
                  <b>
                    {{ user["plan_name"] }}
                  </b>
                </div>
              </div>
            </div>
          </div>

          <div
            class="card p-2 m-2 mb-4"
            style="">
            <div class="p-2 text-center">
              <div class="row">
                <div class="col-5">
                  <small> شروع اشتراک </small>
                </div>

                <div class="col-7">
                  <b v-html="convertToJalali(user['start_date'])"/>
                </div>
              </div>
              <div class="row">
                <div class="col-5">
                  <small> پایان اشتراک </small>
                </div>

                <div class="col-7">
                  <b v-html="convertToJalali(user['end_date'])"/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :is-loading="isLoading" />
  </div>
</template>

<script>
import HoraLogo from '../components/HoraLogo.vue'
import Autocomplete from '@trevoreyre/autocomplete-vue'
import HelperLib from '../components/helper'
import ApiService from '../service/api'
import Loading from '../components/Loading.vue'
import moment from 'jalali-moment'

export default {
  name: 'SubsView',
  components: {
    Loading,
    HoraLogo,
    Autocomplete,
    HelperLib
  },
  data () {
    return {
      success: false,
      error: false,
      isLoading: false,
      user: {}
    }
  },
  mounted () {
    this.populateSettings()
  },
  methods: {
    populateSettings () {
      this.isLoading = true
      ApiService.getUserSubs().then((response) => {
        // console.log(response);
        this.user = response.data
        this.isLoading = false
      })
    },
    convertToJalali (date) {
      if (date != null) { return moment.from(date, 'en', 'YYYY-MM-DD').format('jYYYY-jMM-jDD') }
    }
  }
}
</script>

